import axios from 'axios'
import * as types from '../mutation-types'
import {base64ArrayBuffer} from '../../base64'

const state = {
  globalLogo: null,
  globalTitle: null,
  currentLogo: '/static/img/logo.svg',
  currentTitle: 'IPCOM VORTEX'
}

const getters = {
  currentLogoUrl (state) {
    if (state.currentLogo !== '/static/img/logo.svg') {
      return state.currentLogo
    }
    if (state.globalLogo) {
      return state.globalLogo
    }
    return '/static/img/logo.svg'
  },
  currentSoftwareTitle (state) {
    if (state.currentTitle !== 'IPCOM VORTEX') {
      return state.currentTitle
    }
    if (state.globalTitle) {
      return state.globalTitle
    }
    return 'IPCOM VORTEX'
  }
}

const actions = {
  changeLogo ({commit}, {orgId, orgLogo}) {
    axios({
      method: 'get',
      url: `/orgs/${orgId}/files/${orgLogo}`
    }).then(response => response.data.url)
    .then((url) => {
      const instance = axios.create({baseURL: '', headers: {common: []}})
      delete instance.defaults.headers.common['Authorization']
      return instance({
        url,
        method: 'get',
        responseType: 'arraybuffer'
      })
    }
    ).then((response) => {
      const data = base64ArrayBuffer(response.data)
      return `data:${response.headers['content-type']};base64,${data}`
    }
    ).then((url) => {
      commit(types.SET_CURRENT_LOGO, url)
    })
  }
}

const mutations = {
  [types.SET_CURRENT_LOGO] (state, logo) {
    state.currentLogo = logo
  },
  [types.SET_CURRENT_TITLE] (state, title) {
    state.currentTitle = title
  },
  [types.SET_GLOBAL_LOGO] (state, logo) {
    state.globalLogo = logo
  },
  [types.SET_GLOBAL_TITLE] (state, title) {
    state.globalTitle = title
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vcc-conf.js